// Angular dependencies
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Imports modules
import { PageCreepComponent } from './page-creep.component';

const routes: Routes = [{
  path: 'creep',
  pathMatch: 'full',
  component: PageCreepComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class PageCreepRouterModule {
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-creep.module/page-creep.router.ts